"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactFormAnalyticsService = void 0;
const forms_service_ui_1 = require("@danfoss/forms-service-ui");
const app_1 = require("app");
const Forms_1 = require("../Forms");
const formAliasToFormTypeMapping = {
    [forms_service_ui_1.FormTypes.DistributorForm]: Forms_1.FormTypeEnum.Distributors,
    [forms_service_ui_1.FormTypes.DPSDistributorsForm]: Forms_1.FormTypeEnum.DpsDistributors,
    [forms_service_ui_1.FormTypes.PardotForm]: Forms_1.FormTypeEnum.Pardot,
    [forms_service_ui_1.FormTypes.ServiceCloudForm]: Forms_1.FormTypeEnum.ServiceCloud,
};
class ContactFormAnalyticsService {
    constructor() {
        this.trackFormLoadError = (companyName) => {
            app_1.GTM.contactFormLoadError(companyName);
        };
        this.trackFormSubmit = (formAlias, formTitle) => {
            const formType = formAliasToFormTypeMapping[formAlias];
            app_1.GTM.form.submit({ formType }, formTitle);
        };
        this.trackValidationErrors = (formAlias, formTitle, errors, isBackend = false) => {
            const formType = formAliasToFormTypeMapping[formAlias];
            if (!Array.isArray(errors))
                return;
            errors.forEach(error => {
                const errorFieldName = error && error.name;
                app_1.GTM.form.error({ formType }, isBackend, formTitle, errorFieldName);
            });
        };
        this.trackGenericFormError = (formAlias, formTitle) => {
            const formType = formAliasToFormTypeMapping[formAlias];
            app_1.GTM.form.error({ formType }, true, formTitle);
        };
        this.trackFormSubmitSuccess = (formAlias, formTitle) => {
            const formType = formAliasToFormTypeMapping[formAlias];
            app_1.GTM.form.success({ formType }, formTitle);
        };
        this.trackFormAbandon = (formAlias, formTitle) => {
            const formType = formAliasToFormTypeMapping[formAlias];
            app_1.GTM.form.abandon({ formType }, formTitle);
        };
        this.trackServiceProcessesRedirect = (formAlias, formTitle, url) => {
            const formType = formAliasToFormTypeMapping[formAlias];
            app_1.GTM.form.formRedirect({ url, formType, customFormName: formTitle });
        };
    }
}
const instance = new ContactFormAnalyticsService();
exports.ContactFormAnalyticsService = instance;
